<template>
    <div class="omni-theme-picker">
        <div class="theme-boxes">
            <ThemeBox
                v-for="(theme, key) in availableThemes"
                :key="key"
                :backgroundColor="theme.colors[0]"
                :foregroundColor="theme.colors[1]"
                :active="selectedTheme === key"
                @click="selectTheme(key)"
                :title="`Thema '${theme.display_name}' selecteren`"
                v-b-tooltip.hover
            />
        </div>
    </div>
</template>

<script>
import themes from "@/components/OmniStock/ThemePicker/themes.json";

import ThemeBox from './ThemeBox.vue';

export default {
    components: {
        ThemeBox
    },
    props: {
        value: {
            type: String,
            required: true,
            default: 'default'
        },
        options: {
            type: Array,
            require: true,
        },
        disabled: {
            default: false,
        },
    },
    data() {
        return {
            themes,
        };
    },
    methods: {
        selectTheme(themeKey) {
            if (this.disabled) {
                return
            }

            this.$emit('input', themeKey);
        }
    },
    computed: {
        selectedTheme() {
            return this.value;
        },
        availableThemes() {
            return Object.keys(this.themes).filter(key => this.options.includes(key))
                .reduce((obj, key) => {
                    obj[key] = this.themes[key];
                    return obj;
                }, {});
        }
    }
};
</script>

<style lang="scss">
.omni-theme-picker {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;

    .theme-boxes {
        display: flex;
        gap: 1rem;
    }

    .label-selected {
        font-size: .9rem;
    }
}
</style>
